import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from '@nuxtjs/composition-api'
import { ILanguage } from './../../model/types'
import { Cookie } from '@shared/lib'


export default /*#__PURE__*/_defineComponent({
  __name: 'TranslatorSelect',
  emits: ['googleTranslate'],
  setup(__props, { emit: emits }) {



// const lang = ref<string>('ru')
const langFirstVisit = ref<string>('ru')
const isActive = ref<boolean>(false)
const languages: ILanguage[] = [
  { id: 0, from: 'zh-CN', to: 'en', imageFrom: 'translator__ch-en.svg', imageTo: 'translator-EN.svg' },
  { id: 1, from: 'zh-CN', to: 'ru', imageFrom: 'translator__ch-ru.svg', imageTo: 'translator-RU.svg' },
  { id: 2, from: 'en', to: 'ru', imageFrom: 'translator__en-ru.svg', imageTo: 'translator-RU.svg' },
  { id: 3, from: 'en', to: 'zh-CN', imageFrom: 'translator__en-ch.svg', imageTo: 'translator-CH.svg' },
  { id: 4, from: 'ru', to: 'en', imageFrom: 'translator__ru-en.svg', imageTo: 'translator-EN.svg' },
  { id: 5, from: 'ru', to: 'zh-CN', imageFrom: 'translator__ru-ch.svg', imageTo: 'translator-CH.svg' }
]

const langUi = computed(() => {
  return langFirstVisit.value === 'zh-CN'
    ? 'CH'
    : langFirstVisit.value === 'en' ? 'EN' : 'RU'
})

const sendLanguageSwitchMetric = () => {
  if (typeof window !== 'undefined' && (window as any).ym) {
    (window as any).ym(process.env.YA_METRIK_ID, 'reachGoal', 'language_switch_click')
  }
}

const onTranslation = (to: string) => {
  sendLanguageSwitchMetric()
  Cookie.set('languageCookies', to, 365)
  langFirstVisit.value = to
  Cookie.set('googtrans', '/en/' + langFirstVisit.value)
  isActive.value = false
  location.reload()
}

onMounted(() => {
  const languageCookies = Cookie.get('languageCookies') || 'ru'
  if (languageCookies) {
    langFirstVisit.value = languageCookies
  }
  if (languageCookies === 'ru') {
    return
  }
  Cookie.set('googtrans', '/auto/' + languageCookies)
  setTimeout(() => {
    emits('googleTranslate', languageCookies)
  }, 2000)
})


return { __sfc: true,emits, langFirstVisit, isActive, languages, langUi, sendLanguageSwitchMetric, onTranslation }
}

})